import axios from "axios";
import api from "./api";

// Documentações técnicas (só ADMIN). Backend: /api/v1/documentations

export type DocumentationFile = {
    key: string;
    title: string;
    description: string;
    filename: string;
    type: 'markdown' | 'insomnia';
    available: boolean;
    size: number | null;
    updated_at: string | null;
};

export type DocumentationList = {
    files: DocumentationFile[];
    openapi: { title: string; description: string; docs_url: string; openapi_url: string };
};

export const getDocumentations = async (): Promise<DocumentationList> => (await api.get('documentations')).data;

export const getDocumentationContent = async (key: string): Promise<string> =>
    (await api.get(`documentations/${key}/content`)).data.content;

const saveBlob = (blob: Blob, filename: string) => {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
};

export const downloadDocumentation = async (file: DocumentationFile) => {
    const response = await api.get(`documentations/${file.key}/download`, { responseType: 'blob' });
    saveBlob(response.data, file.filename);
};

// openapi.json é público (sem token): baixa direto da API pública
export const downloadOpenApi = async (url: string) => {
    const response = await axios.get(url, { responseType: 'blob' });
    saveBlob(response.data, 'openapi.json');
};
